import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Gmap from './Gmap';
import Select, { components } from 'react-select';
import Slider from '@mui/material/Slider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {
  homeTypeOptions,
  unitTypeOptions,
  propertyFeaturesOptions,
  rentalPropertyFeaturesOptions,
} from '../contants/data';
import useToggle from '../hooks/useToggle';
// ICONS
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';

const FiltersMobile = ({ onFilter, data, stateCategory, filters }) => {
  const [thunks, setThunks] = useState(null);
  const [showAdvFilter, setShowAdvFilter] = useState(false);
  const { isFilter } = useSelector((state) => state[stateCategory]);
  const [selectedOption, setSelectedOption] = useState(null);

  const dispatch = useDispatch();

  const handleRemoveOption = (removedOption) => {
    const updatedOption = selectedOption.filter(
      (option) => option !== removedOption
    );
    setSelectedOption(updatedOption);
  };

  // GEOLOCATE
  const { lat, lng, radius } = useSelector(
    (state) => state[stateCategory].filters.location
  );

  // NEW LAT,LNG
  const [newLat, setNewLat] = useState('');
  const [newLng, setNewLng] = useState('');

  // PRICE
  const { min: priceMin, max: priceMax } = useSelector(
    (state) => state[stateCategory].filters.price_range
  );
  const [priceVal, setPriceVal] = useState([priceMin, priceMax]);
  const [togglePrice, handleTogglePrice] = useToggle();
  const handlePriceChange = (event, newValue) => {
    setPriceVal(newValue);
    dispatch(thunks?.changePrice({ min: newValue[0], max: newValue[1] }));
  };
  const handleMinPriceChange = (e) => {
    const newMin = Number(e.target.value);
    setPriceVal([newMin, priceVal[1]]);
    dispatch(thunks?.changePrice({ min: newMin, max: priceVal[1] }));
  };

  const handleMaxPriceChange = (e) => {
    const newMax = Number(e.target.value);
    setPriceVal([priceVal[0], newMax]);
    dispatch(thunks?.changePrice({ min: priceVal[0], max: newMax }));
  };

  // BEDS
  const { min: bedsMin, max: bedsMax } = useSelector(
    (state) => state[stateCategory].filters.beds_range
  );
  const [bedsVal, setBedsVal] = useState([bedsMin, bedsMax]);
  const [toggleBeds, handleToggleBeds] = useToggle();
  const handleBedsChange = (event, newValue) => {
    setBedsVal(newValue);
    dispatch(thunks?.changeBeds({ min: newValue[0], max: newValue[1] }));
  };

  // SLEEPS
  const { min: sleepsMin, max: sleepsMax } = useSelector(
    (state) => state[stateCategory].filters.sleeps_range
  );
  const [sleepsVal, setSleepsVal] = useState([sleepsMin, sleepsMax]);
  const [toggleSleeps, handleToggleSleeps] = useToggle();
  const handleSleepsChange = (event, newValue) => {
    setSleepsVal(newValue);
    dispatch(thunks?.changeSleeps({ min: newValue[0], max: newValue[1] }));
  };

  // BATHS
  const { min: bathsMin, max: bathsMax } = useSelector(
    (state) => state[stateCategory].filters.baths_range
  );
  const [bathsVal, setBathsVal] = useState([bathsMin, bathsMax]);
  const [toggleBaths, handleToggleBaths] = useToggle();
  const handleBathsChange = (event, newValue) => {
    setBathsVal(newValue);
    dispatch(thunks?.changeBaths({ min: newValue[0], max: newValue[1] }));
  };

  // SIZE SQFT
  const { min: sizeSqFtMin, max: sizeSqFtMax } = useSelector(
    (state) => state[stateCategory].filters.size_sqft_range
  );
  const [sizeSqFtVal, setSizeSqFtVal] = useState([sizeSqFtMin, sizeSqFtMax]);
  const [toggleSizeSqFt, handleToggleSizeSqFt] = useToggle();
  const handleSizeSqFtChange = (event, newValue) => {
    setSizeSqFtVal(newValue);
    dispatch(thunks?.changeSizeSqFt({ min: newValue[0], max: newValue[1] }));
  };

  // Home Type
  const { homeType } = useSelector((state) => state[stateCategory].filters);
  const [selectedHomeType, setSelectedHomeType] = useState([]);
  const [toggleHomeType, handleToggleHomeType] = useToggle();
  const handleHomeTypeChange = (options) => {
    setSelectedHomeType(options ? options.map((option) => option.value) : []);
    dispatch(
      thunks?.changeHomeType(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // Unit Type
  const { unitType } = useSelector((state) => state[stateCategory].filters);
  const [selectedUnitType, setSelectedUnitType] = useState([]);
  const [toggleUnitType, handleToggleUnitType] = useToggle();
  const handleUnitTypeChange = (options) => {
    setSelectedUnitType(options ? options.map((option) => option.value) : []);
    dispatch(
      thunks?.changeUnitType(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // Property Features
  const { propertyFeatures } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedPropertyFeatures, setSelectedPropertyFeatures] = useState([]);
  const [togglePropertyFeatures, handleTogglePropertyFeatures] = useToggle();
  const handlePropertyFeaturesChange = (options) => {
    setSelectedPropertyFeatures(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changePropertyFeatures(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // Rental Property Features
  const { rentalPropertyFeatures } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedRentalPropertyFeatures, setSelectedRentalPropertyFeatures] =
    useState([]);
  const [toggleRentalPropertyFeatures, handleToggleRentalPropertyFeatures] =
    useToggle();
  const handleRentalPropertyFeaturesChange = (options) => {
    setSelectedRentalPropertyFeatures(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changeRentalPropertyFeatures(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  useEffect(() => {
    const loadThunks = async () => {
      let importedThunks;
      if (stateCategory === 'longTermHousingRentals') {
        importedThunks = await import(
          '../store/slices/longTermHousingRentals.slice'
        );
      }
      setThunks(importedThunks);
    };

    loadThunks();
  }, [stateCategory]);

  if (!thunks) {
    return <div>Loading...</div>;
  }

  const handleSubmit = () => {
    let finalLat = '';
    let finalLng = '';
    if ((newLat != '') & (newLng != '')) {
      finalLat = newLat;
      finalLng = newLng;
      dispatch(thunks?.changeLocation({ lat: finalLat, lng: finalLng }));
    } else {
      finalLat = lat;
      finalLng = lng;
    }

    onFilter({
      finalLat,
      finalLng,
      radius,
      priceVal,
      bedsVal,
      sleepsVal,
      bathsVal,
      sizeSqFtVal,
      homeType,
      unitType,
      propertyFeatures,
      rentalPropertyFeatures,
    });
    dispatch(thunks?.activateFilter(true));
    dispatch(thunks?.setSearchTerm(''));
    dispatch(thunks?.setSortBy('Closest to Me'));
    dispatch(thunks?.resetSortedData());
  };

  const updateLoc = (lat, lng) => {
    setNewLat(() => {
      return lat;
    });
    setNewLng(() => {
      return lng;
    });
  };

  const handleResetFilter = () => {
    window.location.reload();
  };

  const handleShowAdvFilter = () => {
    setShowAdvFilter(!showAdvFilter);
  };

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: 'none',
      fontSize: '14px', // Remove the border
      boxShadow: state.isFocused ? 'none' : provided.boxShadow, // Remove the box shadow on focus
      '&:hover': {
        borderColor: 'none', // Remove border color on hover
      },
      cursor: 'pointer', // Change cursor to pointer to indicate interaction
    }),
    indicatorSeparator: () => ({
      display: 'none', // Hide the indicator separator
    }),
    dropdownIndicator: () => ({
      display: 'none', // Hide the dropdown indicator
    }),
    input: () => ({
      display: 'none', // Hide the input field
    }),
  };

  return (
    <div className='sidebar mobile hide-desktop'>
      <Gmap onChangeLoc={updateLoc} data={data} />
      {filters.includes('Price') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Price</label>
            <span>
              {!togglePrice && (
                <div className='price-range-wrap mt-0'>
                  <span>${priceVal[0].toLocaleString('en-US')} - </span>
                  <span>${priceVal[1].toLocaleString('en-US')}</span>
                </div>
              )}
            </span>
            <button className='btn-toggle' onClick={handleTogglePrice}>
              {togglePrice ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {togglePrice && (
            <>
              {/* <Slider
                value={priceVal}
                onChange={handlePriceChange}
                valueLabelDisplay="auto"
                max={2000000}
                step={1000}
              />
              <div className="price-range-wrap mt-0 ">
                <span>${priceVal[0].toLocaleString("en-US")} - </span>
                <span>${priceVal[1].toLocaleString("en-US")}</span>
              </div> */}
              <div className='range-inputs'>
                <input
                  type='number'
                  value={priceVal[0]}
                  min={0}
                  onChange={handleMinPriceChange}
                  placeholder='Min'
                />
                <span className='price-separator'>–</span>
                <input
                  type='number'
                  value={priceVal[1]}
                  min={0}
                  onChange={handleMaxPriceChange}
                  placeholder='Max'
                />
              </div>
            </>
          )}
        </div>
      )}
      {filters.includes('Beds') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Beds</label>
            <span>
              {!toggleBeds && (
                <div className='price-range-wrap mt-0 '>
                  <span>{bedsVal[0].toLocaleString('en-US')} - </span>
                  <span>{bedsVal[1].toLocaleString('en-US')}</span>
                </div>
              )}
            </span>
            <button className='btn-toggle' onClick={handleToggleBeds}>
              {toggleBeds ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleBeds && (
            <>
              <div className='range-inputs'>
                <input
                  type='number'
                  value={bedsVal[0]}
                  min={0}
                  onChange={(e) => {
                    const newMin = Number(e.target.value);
                    setBedsVal([newMin, bedsVal[1]]);
                    dispatch(
                      thunks?.changeBeds({ min: newMin, max: bedsVal[1] })
                    );
                  }}
                  placeholder='Min'
                />
                <span className='price-separator'>–</span>
                <input
                  type='number'
                  value={bedsVal[1]}
                  min={0}
                  onChange={(e) => {
                    const newMax = Number(e.target.value);
                    setBedsVal([bedsVal[0], newMax]);
                    dispatch(
                      thunks?.changeBeds({ min: bedsVal[0], max: newMax })
                    );
                  }}
                  placeholder='Max'
                />
              </div>
            </>
          )}
        </div>
      )}
      {filters.includes('Sleeps') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Sleeps</label>
            <span>
              {!toggleSleeps && (
                <div className='price-range-wrap mt-0 '>
                  <span>{sleepsVal[0].toLocaleString('en-US')} - </span>
                  <span>{sleepsVal[1].toLocaleString('en-US')}</span>
                </div>
              )}
            </span>
            <button className='btn-toggle' onClick={handleToggleSleeps}>
              {toggleSleeps ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleSleeps && (
            <>
              <Slider
                value={sleepsVal}
                onChange={handleSleepsChange}
                valueLabelDisplay='auto'
                max={20}
                step={1}
              />
              <div className='price-range-wrap mt-0 '>
                <span>{sleepsVal[0].toLocaleString('en-US')} - </span>
                <span>{sleepsVal[1].toLocaleString('en-US')}</span>
              </div>
            </>
          )}
        </div>
      )}
      {filters.includes('Baths') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Baths</label>
            <span>
              {!toggleBaths && (
                <div className='price-range-wrap mt-0 '>
                  <span>{bathsVal[0].toLocaleString('en-US')} - </span>
                  <span>{bathsVal[1].toLocaleString('en-US')}</span>
                </div>
              )}
            </span>
            <button className='btn-toggle' onClick={handleToggleBaths}>
              {toggleBaths ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleBaths && (
            <>
              <div className='range-inputs'>
                <input
                  type='number'
                  value={bathsVal[0]}
                  min={0}
                  onChange={(e) => {
                    const newMin = Number(e.target.value);
                    setBathsVal([newMin, bathsVal[1]]);
                    dispatch(
                      thunks?.changeBaths({ min: newMin, max: bathsVal[1] })
                    );
                  }}
                  placeholder='Min'
                />
                <span className='price-separator'>–</span>
                <input
                  type='number'
                  value={bathsVal[1]}
                  min={0}
                  onChange={(e) => {
                    const newMax = Number(e.target.value);
                    setBathsVal([bathsVal[0], newMax]);
                    dispatch(
                      thunks?.changeBaths({ min: bathsVal[0], max: newMax })
                    );
                  }}
                  placeholder='Max'
                />
              </div>
            </>
          )}
        </div>
      )}
      {filters.includes('Size_sqft') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Size (SQ. FT.)</label>
            <span>
              {!toggleSizeSqFt && (
                <div className='price-range-wrap mt-0 '>
                  <span>{sizeSqFtVal[0].toLocaleString('en-US')} - </span>
                  <span>{sizeSqFtVal[1].toLocaleString('en-US')}</span>
                </div>
              )}
            </span>
            <button className='btn-toggle' onClick={handleToggleSizeSqFt}>
              {toggleSizeSqFt ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleSizeSqFt && (
            <>
              <div className='range-inputs'>
                <input
                  type='number'
                  value={sizeSqFtVal[0]}
                  min={0}
                  onChange={(e) => {
                    const newMin = Number(e.target.value);
                    setSizeSqFtVal([newMin, sizeSqFtVal[1]]);
                    dispatch(
                      thunks?.changeSizeSqFt({
                        min: newMin,
                        max: sizeSqFtVal[1],
                      })
                    );
                  }}
                  placeholder='Min'
                />
                <span className='price-separator'>–</span>
                <input
                  type='number'
                  value={sizeSqFtVal[1]}
                  min={0}
                  onChange={(e) => {
                    const newMax = Number(e.target.value);
                    setSizeSqFtVal([sizeSqFtVal[0], newMax]);
                    dispatch(
                      thunks?.changeSizeSqFt({
                        min: sizeSqFtVal[0],
                        max: newMax,
                      })
                    );
                  }}
                  placeholder='Max'
                />
              </div>
            </>
          )}
        </div>
      )}
      {filters.includes('Home Type') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Home Type</label>
            <span>
              {!toggleHomeType && (
                <Select
                  options={homeTypeOptions}
                  onChange={handleHomeTypeChange}
                  value={homeTypeOptions.filter((option) =>
                    selectedHomeType.includes(option.value)
                  )}
                  placeholder='Select'
                  styles={selectStyles}
                  menuIsOpen={false}
                  className='border-0'
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button className='btn-toggle' onClick={handleToggleHomeType}>
              {toggleHomeType ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleHomeType && (
            <Select
              isMulti
              options={homeTypeOptions}
              onChange={handleHomeTypeChange}
              value={homeTypeOptions.filter((option) =>
                selectedHomeType.includes(option.value)
              )}
              className='border-0'
            />
          )}
        </div>
      )}
      {filters.includes('Unit Type') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Unit Type</label>
            <span>
              {!toggleUnitType && (
                <Select
                  options={unitTypeOptions}
                  onChange={handleUnitTypeChange}
                  value={unitTypeOptions.filter((option) =>
                    selectedUnitType.includes(option.value)
                  )}
                  placeholder='Select'
                  styles={selectStyles}
                  menuIsOpen={false}
                  className='border-0'
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button className='btn-toggle' onClick={handleToggleUnitType}>
              {toggleUnitType ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleUnitType && (
            <Select
              isMulti
              options={unitTypeOptions}
              onChange={handleUnitTypeChange}
              value={unitTypeOptions.filter((option) =>
                selectedUnitType.includes(option.value)
              )}
              className='border-0'
            />
          )}
        </div>
      )}
      {filters.includes('Property Features') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Property Features</label>
            <span>
              {!togglePropertyFeatures && (
                <Select
                  options={propertyFeaturesOptions}
                  onChange={handlePropertyFeaturesChange}
                  value={propertyFeaturesOptions.filter((option) =>
                    selectedPropertyFeatures.includes(option.value)
                  )}
                  placeholder='Select'
                  styles={selectStyles}
                  menuIsOpen={false}
                  className='border-0'
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className='btn-toggle'
              onClick={handleTogglePropertyFeatures}
            >
              {togglePropertyFeatures ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {togglePropertyFeatures && (
            <Select
              isMulti
              options={propertyFeaturesOptions}
              onChange={handlePropertyFeaturesChange}
              value={propertyFeaturesOptions.filter((option) =>
                selectedPropertyFeatures.includes(option.value)
              )}
              className='border-0'
            />
          )}
        </div>
      )}
      {filters.includes('Rental Property Features') && (
        <div className='form-control-wrap'>
          <div className='label-2-cols'>
            <label>Rental Property Features</label>
            <span>
              {!toggleRentalPropertyFeatures && (
                <Select
                  options={rentalPropertyFeaturesOptions}
                  onChange={handleRentalPropertyFeaturesChange}
                  value={rentalPropertyFeaturesOptions.filter((option) =>
                    selectedRentalPropertyFeatures.includes(option.value)
                  )}
                  placeholder='Select'
                  styles={selectStyles}
                  menuIsOpen={false}
                  className='border-0'
                  isMulti
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  components={{
                    MultiValueRemove: (props) => (
                      <components.MultiValueRemove
                        {...props}
                        onClick={() => handleRemoveOption(props.data)}
                      />
                    ),
                  }}
                />
              )}
            </span>
            <button
              className='btn-toggle'
              onClick={handleToggleRentalPropertyFeatures}
            >
              {toggleRentalPropertyFeatures ? 'Hide Filter' : 'Edit Filter'}
            </button>
          </div>
          {toggleRentalPropertyFeatures && (
            <Select
              isMulti
              options={rentalPropertyFeaturesOptions}
              onChange={handleRentalPropertyFeaturesChange}
              value={rentalPropertyFeaturesOptions.filter((option) =>
                selectedRentalPropertyFeatures.includes(option.value)
              )}
              className='border-0'
            />
          )}
        </div>
      )}
      <button onClick={() => handleSubmit()} className='primary mb-10'>
        Filter
      </button>
      <button
        onClick={() => handleResetFilter()}
        className='reset'
        disabled={!isFilter}
      >
        Reset Filter
      </button>
    </div>
  );
};

export default FiltersMobile;
